import { CmsComponent, Converter } from '@spartacus/core'
import { Injectable, InjectionToken } from '@angular/core'
import { ConvertedComponentData, FsCatalog } from '../types'
import { CmsConverterService, defaultFSCatalog } from '../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class CongressContainerConverter extends CmsConverterService<CongressContainerData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      backgroundColor: formData.st_backgroundcolor?.value?.identifier ?? '',
      fullWidth: formData.st_full_width?.value ?? false,
      elements: formData.st_container ?? defaultFSCatalog
    }
  }
}

export const CONGRESS_CONTAINER_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, CongressContainerData>>('CongressContainerConverter')

export interface CongressContainerData extends ConvertedComponentData {
  backgroundColor: string;
  fullWidth: boolean;
  elements: FsCatalog;
}
